module.exports = require("@adobe/aem-react-editable-components");